"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Bottom = function Bottom(_ref) {
  var _ref$noSpacer = _ref.noSpacer,
      noSpacer = _ref$noSpacer === void 0 ? false : _ref$noSpacer,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, !noSpacer && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: '1'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      minWidth: '100%',
      margin: 0,
      padding: 0,
      // position: 'fixed',
      // bottom: '5%',
      // left: 0,
      // right: 0,
      marginTop: '5%',
      marginBottom: '5%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }
  }, children));
};

var _default = Bottom;
exports["default"] = _default;